import { Attr } from '../attr/attr';
import { CaseQuestionContent } from './case-question-content';
import { QuestionContent } from './question-content';
import { QuestionType } from './question-type.enum';
import {Score} from './score';

export class Question {
  answeredNum: number;
  attrs: Attr[];
  correctAnsweredNum: number;
  createAccountId: number;
  createTime: number;
  enabled: boolean;
  id: number;
  lastModified: number;
  preId: number;
  qusContent: QuestionContent | CaseQuestionContent;
  refCount: number;
  resId: string;
  type: QuestionType;
  updateAccountId: number;
  scores: Score[];

  constructor(type = QuestionType.SINGLE_SELECT) {
    this.attrs = [];
    this.qusContent = new QuestionContent(type);
  }
}
